import styled from 'styled-components';

export const PieDonutWidgetStyled = styled.div``;
